import React, { useState } from 'react';
// Constants
import { CompanyName, MainTitle } from '../../utils/Constants';
// Components
import Navbar from '../../components/nav/Navbar';
// Icons
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosArrowForward } from 'react-icons/io';

function HomePageHeader() {
  // Array of background classes
  const backgrounds = ['bg-newmain', 'bg-paraAlt', 'bg-para3'];

  // State for current background index
  const [currentBg, setCurrentBg] = useState(0);

  // Handlers for left/right buttons
  const handlePrevBackground = () => {
    setCurrentBg((prevIndex) =>
      prevIndex === 0 ? backgrounds.length - 1 : prevIndex - 1
    );
  };

  const handleNextBackground = () => {
    setCurrentBg((prevIndex) =>
      prevIndex === backgrounds.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <header className='grid h-full border-b-2 border-solid border-colour7 fixed w-full'>
      <div
        className={`grid ${backgrounds[currentBg]} bg-cover bg-no-repeat bg-[center_top_30%] full_shadow_black_invert_big`}
      >
        <div className='grid h-fit z-100'>
          <Navbar />
        </div>

        {/* Background switch buttons */}
        <button
          onClick={handlePrevBackground}
          className='absolute pointer-events-auto z-50 left-12 top-1/2 transform -translate-y-1/2 bg-black/50 text-white px-4 py-2 rounded-r cursor-pointer hover:bg-black/70'
        >
          <IoIosArrowBack size={40} />
        </button>

        <button
          onClick={handleNextBackground}
          className='absolute pointer-events-auto z-50 right-12 top-1/2 transform -translate-y-1/2 bg-black/50 text-white px-4 py-2 rounded-l cursor-pointer hover:bg-black/70'
        >
          <IoIosArrowForward size={40} />
        </button>

        <section className='grid'>
          <article className='grid'>
            <div className='absolute md:left-8 lg:left-16 top-24'>
              <h1 className='md:text-2xl font-charm text-center'>
                "A beauty that effortlessly commands submission, complete
                devotion and total <br /> obedience"
              </h1>
              <section className='grid lg:hidden text-center pt-6'>
                <div>
                  <h1 className='font-hello-paris-medium text-4xl lg:text-8xl text_shadow_strong'>
                    {CompanyName}
                  </h1>
                </div>
                <div>
                  <h2 className='lg:text-xl font-kugile text_shadow'>
                    {MainTitle}
                  </h2>
                </div>
              </section>
            </div>

            {/* Buttons */}
            {/* <section className='grid lg:grid-cols-2 gap-2 px-8'>
              <button className='px-2 py-2 border-2 border-solid border-colour1 hover:bg-transparent bg-colour4 font-hello-paris-medium lg:text-xl'>
                Learn More
              </button>
              <button className='px-2 py-2 border-2 border-solid border-colour1 bg-colour2 hover:bg-colour4 font-hello-paris-medium lg:text-xl'>
                Book A Session
              </button>
            </section> */}
          </article>
        </section>
      </div>
    </header>
  );
}

export default HomePageHeader;
